<template>
	<GridItem>
		<div class="appointment-card-container pd">
			<div class="appointment-card-header" :style="{ backgroundColor: statusBgColor }">
				<div class="appointment-card-speciality">{{ appointment.patient.name }} &rarr; {{ appointment.department.title }}</div>
				<div class="appointment-card-status">{{ statusText }}</div>
			</div>
			<div class="appointment-card-content">
				<div v-if="appointment.status == 'done' || appointment.status == 'passed' ">
					<div>Записан на <strong>{{ appointmentDatetimeStr }}</strong></div>
					<div>к врачу <strong>{{ appointment.appointment_doctor.name }}</strong></div>
					<div v-if="appointment.appointment_doctor.room.length > 0">кабинет <strong>{{ appointment.appointment_doctor.room }}</strong></div>
				</div>
				<div v-else>
					<div v-html="doctorsText" />
					<div v-html="selectedDaysText" class="pd-vertical"/>
					<div v-if="!appointment.quick_mode" class="pd-vertical">🌜  Запрет записи день в день</div>
					<div v-if="selectedTimeRangeText" v-html="selectedTimeRangeText" class="pd-vertical"/>
					<div class="appointment-card-button-container" v-if="showCancelButton">
						<Button round plain :color="GRAY_COLOR" size="small" @click="onCancelInner" class="appointment-card-button" :disabled="buttonDisabled">
							Отменить поиск
						</Button>
					</div>
				</div>
			</div>
		</div>
	</GridItem>
</template>

<script>
import { ref } from 'vue';
import { Button, GridItem } from 'vant';
import { GRAY_COLOR } from '@/components/common/utils';
import { getSelectedTimeRangeText, datetimeToString, TIME_PERIODS_START, TIME_PERIODS_END } from '@/components/common/dateUtils';
import { AppointmentStatuses, AppointmentStatusProps } from '@/models/appointment';

export default {
	components: {
		Button, GridItem,
	},
	props: ['appointment', 'onCancel'],
	setup() {
		const buttonDisabled = ref(false);
		return {
			GRAY_COLOR,
			buttonDisabled,
		};
	},
	computed: {
		doctorsText() {
			if (this.appointment.doctors.length > 0) {
				return this.appointment.doctors.map(doc => doc.name).join('<br>');
			} else {
				return 'Любой доктор';
			}
		},
		statusText() {
			return AppointmentStatusProps[this.appointment.status].text;
		},
		statusBgColor() {
			return AppointmentStatusProps[this.appointment.status].bgcolor;
		},
		selectedTimeRangeText() {
			return getSelectedTimeRangeText(this.appointment.time_condition, TIME_PERIODS_START, TIME_PERIODS_END);
		},
		selectedDaysText() {
			let result = 'Запись в даты: ';
			let delimiter = ', ';
			if (this.appointment.date_condition.length >= 3) {
				delimiter = '<br>';
				result += delimiter;
			}
			return result + this.appointment.date_condition.map(e => '<strong>' + e + '</strong>').join(delimiter);
		},
		showCancelButton() {
			return this.appointment.status == AppointmentStatuses.WAITING;
		},
		appointmentDatetimeStr() {
			return datetimeToString(new Date(this.appointment.appointment_datetime));
		},
	},
	methods: {
		onCancelInner() {
			this.buttonDisabled = true;
			this.onCancel(this.appointment.id);
		}
	},
}
</script>

<style scoped>
.appointment-card-container {
	width: 100%;
	margin: 0;
	font-size: var(--van-cell-font-size);
	line-height: var(--van-cell-line-height);
	color: var(--van-field-label-color);
}
.appointment-card-button-container {
	text-align: right;
}
.appointment-card-header {
	display: flex;
	padding: 8px;
}
.appointment-card-speciality {
	flex-grow: 1;
	font-weight: bold;
}
.appointment-card-content {
	padding: 8px;
}
</style>

<style>
.appointments-container .van-grid-item__content {
	padding: 0;
	border-radius: 8px;
	overflow: hidden;
}
</style>
